import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App';
import routes from './router/index';
import ElementUI from 'element-ui';
import Vuex from 'vuex';
import util from './util';
import store from './vuex/store';
import showtable from './components/template/showtable.vue';

Vue.config.debug = true;
Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(ElementUI);

Vue.component('show-table', showtable)

const router = new VueRouter({
  routes
})

let ter=util.terminalInfo();
let appKey=util.appKey();
window.router = router;



//路由每次发生变化之前，回调方法
router.beforeEach((to, from, next) => {
  //console.log('路由开始 from.path：' + from.path);
  //console.log('路由开始：' + from.name);
  //console.log('路由开始：' + to.name);
  //console.log('路由开始 to.path：' + to.path);
  // let systemInfo = JSON.parse(window.sessionStorage.getItem('systemInfo'));
  // if (!util.isEmptyObject(systemInfo))
  //   $(document)[0].title="万店经销惠-"+systemInfo.systemName;

  let sessionUser = JSON.parse(window.sessionStorage.getItem(appKey));

  if (to.meta.requireAuth) //如果当前路由页面带登录验证，则执行以下路由
  {
    //console.log('path1：' + to.path);
    //console.log('sessionUser：' + sessionUser);
    if (!util.isEmptyObject(sessionUser))
    {
      //检查模块访问权限
      if (to.params.hasOwnProperty('moduleID')){
        if (util.checkUserPower(sessionUser.userId,to.params.moduleID))
          next()
        else
          next({path: '/a00299303'});
      }
      else
        next();
    }
    else {
      //console.log('to.fullPath='+to.fullPath);
      //window.sessionStorage.setItem("jumpUrl",decodeURI(to.fullPath));
      next({
        path: '/login',
        query: {jumpUrl: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  }
  else  //如果当前路由页面不带登录验证，则执行以下路由
  {
    //console.log('path2：' + to.path);
    if (!util.isEmptyObject(sessionUser)) //如果用户已登录
    {
      if (to.fullPath=='/login')  //如果是已经登录的，要跳到登录窗口，则返回到首页
      {
        next({
          path: '/a00299303'
        })
      }
      else
      if (to.query.jumpUrl != undefined) //如果是已经登录的，跳转到指定页面
      {
        //console.log('fullPath2：' + to.query.jumpUrl);
        next({
          path: to.query.jumpUrl
        })
      };
    } else
    {
      //console.log('path：' + to.path);
      //console.log('fullPath：' + to.fullPath);
      //console.log('jumpUrl：' + to.query.jumpUrl);
      if (to.query.jumpUrl != undefined) ////如果是未经登录的，登录后跳转到指定页面
      {
        window.sessionStorage.setItem("jumpUrl",decodeURI(to.fullPath));
      };
      next();
    };
  };
});

//路由每次发生变化之后，回调方法
//router.afterEach(function (transition) {
router.afterEach((to, from, next) => {
  //AOP : 将模块访问信息发送到后台
  //console.log('afterEach from.name='+from.name);
  //console.log('afterEach to.name='+to.name);
  if (from.name && (to.name=="stdModule"||to.name=="stdQuery"))
  {
    let dateNow = new Date();
    //判断用户是否登陆
    let sessionUser=JSON.parse(window.sessionStorage.getItem(appKey));
    if(sessionUser){
      util.myAjax({
        url:util.getUrl()+"/BizQuery/BizQueryBatch",
        dataType:"jsonp",
        data:{
          data:JSON.stringify({
            dataList_0:[{
              "UserNO":sessionUser.userId,
              "TradeDate":dateNow.getFullYear()+'-'+(dateNow.getMonth()+1)+'-'+dateNow.getDate(),
              "Old_LastUpdateTime":dateNow.getFullYear()+'-'+(dateNow.getMonth()+1)+'-'+dateNow.getDate(),
              "BusinessID":"CouponKanban_SystemLogAdd",
              "Operator":sessionUser.userId,
              "OperName":sessionUser.userName,
              "ModuleID":to.params.moduleID,
              "LogoutDate":"",
              "Memo":"",
            }]
          })
        }
      })
    }else{
      //console.log(to.fullPath;
      //暂存要跳转的链接
      window.sessionStorage.setItem("jumpUrl",decodeURI(to.fullPath));
      //重新登录
      next({
        path: '/login',
        query: {jumpUrl: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }
});

/**
 * 金额过滤器
 */
Vue.filter('amountFilter', function (amount) {
  if(amount){
    amount = (amount/10000).toFixed(2)
  }
  return amount+"(万元)";
})

Vue.filter('toDecimal', function (x) {
  if('undefined' == x  || '' == x){
    x = 0;
  }
  var f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  var f = Math.round(x * 100) / 100;
  var s = f.toString();
  var rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
})

new Vue({
  store,
  router,
  el: '#app',
  render: h => h(App),
  data: {
    eventHub: new Vue()
  }
})



// WEBPACK FOOTER //
// ./src/main.js